import { useState } from 'react';
import { AppShell, Burger, Button, Group, NavLink, Text } from '@buildex/ui';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $session, logoutRequested } from '@buildex/core';

/* Разделы «Модули/Брендинг/Пользователи/Роли» — вкладки внутри тенанта */
const MENU: Array<{ labelKey: string; path: string }> = [
  { labelKey: 'menu.tenants', path: '/tenants' },
];

export function AdminLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [session, onLogout] = useUnit([$session, logoutRequested]);
  const [navbarOpened, setNavbarOpened] = useState(true);

  return (
    <AppShell
      header={{ height: 56 }}
      navbar={{
        width: 240,
        breakpoint: 'sm',
        collapsed: { mobile: !navbarOpened, desktop: !navbarOpened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group gap="sm">
            <Burger
              size="sm"
              opened={navbarOpened}
              onClick={() => setNavbarOpened((v) => !v)}
              aria-label="Скрыть/показать меню"
            />
            <Text fw={700}>{t('appName')}</Text>
          </Group>
          <Group gap="sm">
            <Text size="sm" c="dimmed">
              {session?.name}
            </Text>
            <Button variant="subtle" size="xs" onClick={() => onLogout()}>
              {t('logout')}
            </Button>
          </Group>
        </Group>
      </AppShell.Header>
      <AppShell.Navbar p="xs">
        {MENU.map((item) => (
          <NavLink
            key={item.path}
            label={t(item.labelKey)}
            active={pathname.startsWith(item.path)}
            onClick={() => navigate(item.path)}
          />
        ))}
      </AppShell.Navbar>
      <AppShell.Main style={{ background: 'var(--mantine-color-gray-0)' }}>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
